var Queensland = "クイーンズランド";
var Tasmania = "タスマニア";
var Victoria = "ビクトリア";
var AUStates = {
	"Australian Capital Territory": "オーストラリア首都特別地域",
	"New South Wales": "ニューサウスウェールズ",
	"Northern Territory": "ノーザンテリトリー",
	Queensland: Queensland,
	"South Australia": "南オーストラリア",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "西オーストラリア"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
